import http from 'apis/config/http-service';
import { usePageParams } from 'hooks/use-page-params';
import { useInfiniteQuery } from 'react-query';
import type { SalesLookupFamiliesResponse } from './types';

const endpoint = 'api/v1/cms/sales-lookup/families';
export const salesLookupFamiliesEndpointIdentifier = endpoint;

const PAGE_SIZE = 20;

const str = (v: unknown): string | undefined => (typeof v === 'string' && v ? v : undefined);
const num = (v: unknown): number | undefined => {
  const n = Number(v);
  return typeof v === 'string' && v !== '' && !Number.isNaN(n) ? n : undefined;
};

// Infinite-scroll family list for the mobile lookup. `search` matches family
// universalName plus variant brand/origin (BE-side); `restaurantId` scopes the
// closed-price stats. Both live in the URL; paging is internal.
export const useInfiniteSalesLookupFamiliesApi = () => {
  const { getPageParams } = usePageParams();
  const params = getPageParams();

  const search = str(params.search);
  const restaurantId = num(params.restaurantId);

  return useInfiniteQuery(
    [endpoint, 'infinite', search, restaurantId],
    async ({ pageParam = 1 }): Promise<SalesLookupFamiliesResponse> => {
      const { data } = await http.get(endpoint, {
        params: { page: pageParam, limit: PAGE_SIZE, search, restaurantId },
      });
      return data;
    },
    {
      getNextPageParam: (lastPage) => (lastPage.hasNext ? lastPage.page + 1 : undefined),
      keepPreviousData: true,
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 10,
    }
  );
};
